import { gql } from '@lcs/shared/api';

export const getCallCostQuery = gql`
   query GetProviderCallRate($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      providerCallRatesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            providerCallRateId
            providerId
            zone
            rate
            destination
            code
            updateDate
            providerTypeName
         }
      }
   }
`;
